import React, { memo, forwardRef } from "react";
const SvgCapitalPi = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M11 24.136a1 1 0 01-1-1V8a1 1 0 011-1h10.864a1 1 0 011 1v15.136a1 1 0 01-1 1h-.136a1 1 0 01-1-1V9.896a1 1 0 00-1-1H13.16a1 1 0 00-1 1v13.24a1 1 0 01-1 1H11z"
      />
    </svg>
  );
});
SvgCapitalPi.displayName = "SvgCapitalPi";
const MemoForwardRef = memo(SvgCapitalPi);
export default MemoForwardRef;
